/* global google */
import React, { Component } from "react";
import { compose, withProps } from "recompose";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";
import placeholder from "../../../../../images/bg.jpg";
import { SeparateNumberFormat } from "../../../../../services/utils";
import { getIconType } from "../../../../../services/display";
import { getAdFormatLabel } from "../../utils/screenAdsData";

import Colors from '../../../../../themes/Colors';
import { withThemeMapStyles } from '../../../../../themes/mapTheme';
const getMarkerByType = (display) =>
  getIconType(display.display_location_type, display.display_type, false, "isPin");

const CampaignMap = compose(
  withProps((props) => ({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_KEY}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: "100%" }} />,
    containerElement: <div style={{ height: "440px", borderRadius: "12px" }} />,
    mapElement: <div style={{ height: "100%", borderRadius: "12px" }} />,
    ...props,
  })),
  withScriptjs,
  withGoogleMap
)(
  class InnerMap extends Component {
    mapRef = null;
    boundsFitted = false;

    state = { current: null };

    handleMapMount = (map) => {
      this.mapRef = map;
      this.fitMapToBounds();
    };

    componentDidUpdate() {
      this.fitMapToBounds();
    }

    fitMapToBounds = () => {
      const { displays } = this.props;
      if (this.mapRef && displays && displays.length > 0 && !this.boundsFitted) {
        const bounds = new google.maps.LatLngBounds();
        displays.forEach((d) => {
          bounds.extend(
            new google.maps.LatLng(
              parseFloat(d.display_latitude),
              parseFloat(d.display_longitude)
            )
          );
        });
        this.mapRef.fitBounds(bounds, 50);
        this.boundsFitted = true;
      }
    };

    render() {
      const { displays = [], t, isCpmi } = this.props;
      const { current } = this.state;
      return (
        <GoogleMap
          ref={this.handleMapMount}
          defaultZoom={5}
          defaultCenter={{ lat: -24, lng: -65 }}
          options={{
            clickableIcons: false,
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            zoomControl: true,
            styles: withThemeMapStyles([
              { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
              { featureType: "transit", elementType: "labels", stylers: [{ visibility: "off" }] },
            ]),
          }}
        >
          {displays.map((display) => (
            <Marker
              key={display.id}
              position={{
                lat: parseFloat(display.display_latitude),
                lng: parseFloat(display.display_longitude),
              }}
              icon={{
                url: getMarkerByType(display),
                scaledSize: new google.maps.Size(30, 37),
              }}
              onClick={() => this.setState({ current: display })}
            >
              {current === display && (
                <InfoBox
                  onCloseClick={() => this.setState({ current: null })}
                  options={{ closeBoxURL: "", enableEventPropagation: true }}
                >
                  <div
                    style={{
                      width: "240px",
                      background: Colors.snow,
                      borderRadius: "10px",
                      overflow: "hidden",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.18)",
                    }}
                  >
                    <img
                      src={display.display_picture || placeholder}
                      alt=""
                      style={{ width: "100%", height: "120px", objectFit: "cover" }}
                    />
                    <div style={{ padding: "10px 12px" }}>
                      <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6, color: Colors.textStrong }}>
                        {display.display_name}
                      </div>
                      <div style={{ fontSize: 12, color: Colors.textSecondary }}>
                        {t("Screen resolution")}:{" "}
                        <b>
                          {display.display_resolution_width}x{display.display_resolution_height}
                        </b>
                      </div>
                      <div style={{ fontSize: 12, color: Colors.textSecondary }}>
                        {t("Announcement resolution")}: <b>{getAdFormatLabel(display, t)}</b>
                      </div>
                      {!isCpmi && (
                        <div style={{ fontSize: 12, color: Colors.textSecondary }}>
                          {display.belong_to_smart_campaign
                            ? t("Purchased impressions")
                            : t("Promised impressions")}
                          : <b>{SeparateNumberFormat(display.promised_shows)}</b>
                        </div>
                      )}
                    </div>
                  </div>
                </InfoBox>
              )}
            </Marker>
          ))}
        </GoogleMap>
      );
    }
  }
);

export default CampaignMap;
